var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-app page",class:{ 'c-dark-theme': _vm.darkMode }},[_c('Sidebar'),_c('CWrapper',[_c('div',{staticClass:"c-body"},[_c('main',{staticClass:"c-main p-0 position-relative"},[_c('transition',{attrs:{"name":"fade"}},[_c('CElementCover',{directives:[{name:"show",rawName:"v-show",value:(_vm.storePageLoading),expression:"storePageLoading"}],style:({
                          'z-index':1,
                          'background-color':'#f6f6f6'
                      }),attrs:{"boundaries":[{ sides: ['top', 'left'], query: '.media-body' }],"opacity":1}},[_c('CSpinner',{style:({
                              width: '3rem',
                              height: '3rem'

                          }),attrs:{"size":"5xl","color":"primary"}})],1)],1),_c('child')],1)])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }